import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather';
import Fragment from 'vue-fragment';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import * as VueGoogleMaps from 'vue2-google-maps'
import { initializeApp } from "firebase/app";
import vuetify from './plugins/vuetify';
import store from './state';
import { applyRouteSeo } from './seo/route-seo';
import seoContent from './content/seo-content';

const Homepage = () => import("@/views/home");
const Help = () => import("@/views/help");
const AboutUs = () => import("@/views/about-us");
const tc = () => import("@/views/tc");
const driver = () => import("@/components/driver");
const ServicePage = () => import("@/views/service-page");
const ErrorPage = () => import("@/components/404");

var firebaseConfig = {
  apiKey: "AIzaSyCNXy5cCQZdNEnSOOXecJb-ejMfpLOxRK0",
  authDomain: "wrapp-waste.firebaseapp.com",
  databaseURL: "https://wrapp-waste.firebaseio.com",
  projectId: "wrapp-waste",
  storageBucket: "wrapp-waste.appspot.com",
  messagingSenderId: "662553288814",
  appId: "1:662553288814:web:90dd222d1fe2d6766ac67f",
  measurementId: "G-KV0CXS3XRV"
};

initializeApp(firebaseConfig);

Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(VueFeather)
Vue.use(Fragment.Plugin)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB2xcq18UZ60nYqMNnU4E6Mv7nhrEjxAXo',
    libraries: 'places',
    installComponents: true
  }
})

Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyB2xcq18UZ60nYqMNnU4E6Mv7nhrEjxAXo'
});

const router = new VueRouter({
  mode: 'history',
  routes: [{
    path: '/',
    component: Homepage
  }, {
    path: '/help',
    component: Help
  },{
    path: '/tc',
    component: tc
  }, {
    path: '/about',
    component: AboutUs
  }, {
    path: '/driver',
    component: driver
  }, {
    path: '/services/:slug',
    name: 'service',
    component: ServicePage
  }, {
    path: '/error',
    name: 'not-found',
    component: ErrorPage
  }, {
    path: '*',
    component: ErrorPage
  }]
})

router.beforeEach((to, from, next) => {
  if (to.name === 'service' && !seoContent.getServiceBySlug(to.params.slug)) {
    next('/error');
    return;
  }
  next();
});

router.afterEach((to) => {
  Vue.nextTick(() => applyRouteSeo(to.path));
});

applyRouteSeo(window.location.pathname);

new Vue({
  render: h => h(App),
  vuetify,
  router,
  store
}).$mount('#app')
